// removed by extract-text-webpack-plugin
module.exports = {"scriptPopupcontainer":"InspectionScriptPopup__scriptPopupcontainer___yhtGg","popupVeryBig":"InspectionScriptPopup__popupVeryBig___3tinT","closeHeader":"InspectionScriptPopup__closeHeader___22UR2","closeButton1":"InspectionScriptPopup__closeButton1___igARB","textAlign":"InspectionScriptPopup__textAlign___2Yani","inspectionscriptLable":"InspectionScriptPopup__inspectionscriptLable___FxYrD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InspectionScriptPopup/InspectionScriptPopup.css
// module id = 997
// module chunks = 0